/**
 * Protected route component that requires authentication.
 * Now uses global AuthContext, so no race conditions!
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LoadingSpinner } from '@/components/ui/loading';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading, user } = useAuth();

  // Show loading while checking auth state
  if (loading) {
    console.log('ProtectedRoute: Loading auth state...');
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Check authentication
  if (!isAuthenticated || !user) {
    console.log('ProtectedRoute: Not authenticated, redirecting to sign-in');
    return <Navigate to="/auth/sign-in" replace />;
  }

  console.log('ProtectedRoute: Authenticated, rendering children', { userId: user.id });
  return <>{children}</>;
}

